import React from "react";
import { routesConfig } from "@src/core/routes";
import { Navigate, Route, Routes } from "react-router-dom";
import {
  ChecklistFeature,
  DroneFeature,
  FleetFeature,
  HistoryFeature,
  IntegrationFeature,
  OrderFeature,
  ProfileFeature,
  SettingsFeature,
  ViewerFeature,
  ZonesFeature,
  AnalyticsFeature,
} from "@src/features";

const AdminRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/orders/*" element={<OrderFeature />} />
      <Route path="/checklist/*" element={<ChecklistFeature />} />
      <Route path="/zones/*" element={<ZonesFeature />} />
      <Route path="/history/*" element={<HistoryFeature />} />
      <Route path="/drones/*" element={<DroneFeature />} />
      <Route path="/fleet/*" element={<FleetFeature />} />
      <Route path="/viewer/*" element={<ViewerFeature />} />
      <Route path="/profile/*" element={<ProfileFeature />} />
      <Route path="/settings/*" element={<SettingsFeature />} />
      <Route path="/integration/*" element={<IntegrationFeature />} />
      <Route path="/analytics/*" element={<AnalyticsFeature />} />
      <Route path="*" element={<Navigate to={routesConfig.orders} />} />
    </Routes>
  );
};

export default AdminRoutes;
